import React, { useEffect, useState } from 'react';
import { subscribeNotify } from '../../utils/notify';

const ICONS = {
  success: '✓',
  error: '✕',
  warning: '!',
  info: 'i',
  loading: ''
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsub = subscribeNotify((t) => {
      if (t.remove) {
        setToasts((curr) => curr.filter((x) => x.id !== t.id));
        return;
      }
      setToasts((curr) => [...curr, t]);
      if (t.duration > 0) {
        setTimeout(() => {
          setToasts((curr) => curr.filter((x) => x.id !== t.id));
        }, t.duration);
      }
    });
    return unsub;
  }, []);

  const dismiss = (id) => setToasts((curr) => curr.filter((t) => t.id !== id));

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.type}`}>
          <div className="toast-icon">{ICONS[t.type] || ''}</div>
          <div className="toast-content">{t.message}</div>
          {t.type !== 'loading' && (
            <button className="toast-close" onClick={() => dismiss(t.id)}>×</button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
